import {create} from "zustand";

const useTransferStore = create((set, get) => ({
  transferIntention: {
    amount: undefined,
    currency: undefined,
    recipient_name: undefined,
    recipient_email: undefined,
    recipient_id: undefined,
  },
  setTransferIntention: payload => {
    if (!payload.amount) {
      const data = {
        recipient_name: `${payload.first_name} ${payload.last_name}`,
        recipient_email: `${payload.email}`,
        recipient_id: `${payload.id}`,
      };
      return set({transferIntention: {...get().transferIntention, ...data}});
    }
    set({transferIntention: {...get().transferIntention, ...payload}});
  },
  clearTransferIntention: () => set({transferIntention: {}}),
}));

const useCurrentAndSelectedContactStore = create((set, get) => ({
  current: 0,
  setCurrent: current => set({current}),
  // currentContact: null,
  // setCurrentContact: (contact) => set({currentContact: contact}),
  selectedContact: {},
  setSelectedContact: newSelectedContact => set({selectedContact: {...get().selectedContact, ...newSelectedContact}}),
  // transferAmount: 0,
  // setTransferAmount: (amount) => set({transferAmount: amount}),
}));

export {useTransferStore, useCurrentAndSelectedContactStore};
